import ServiceExec from '@/common/utils/ServiceExec';
import { forEach } from 'lodash';

class CommonSvc extends ServiceExec {
  /**
   * 파일 업로드
   * @param params
   * @return {Promise<AxiosResponse<any>>}
   */
  postFileBean(params = {}) {
    const formData = new FormData();
    forEach(params, function (value, key) {
      formData.append(key, value);
    });
    return this.post(`/common/upload`, formData).then((response) => {
      return response.data;
    });
  }

  /**
   * 파일 업로드
   * @param params
   * @return {Promise<AxiosResponse<any>>}
   */
  postFileBeanForS3(params = {}) {
    const formData = new FormData();
    forEach(params, function (value, key) {
      formData.append(key, value);
    });
    return this.post(`/api/common/postFileBeanForS3`, formData).then((response) => {
      return response.data;
    });
  }

  /**
   * 시도 코드 조회
   * @param params
   * @return {Promise<AxiosResponse<any>>}
   */
  getMapZipProvince(params = {}) {
    return this.get(`/common/provinces`, params).then((response) => {
      return response.data;
    });
  }

  /**
   * 구/군 코드 조회
   * @param params
   * @return {Promise<AxiosResponse<any>>}
   */
  getMapZipCity(params = {}) {
    return this.get(`/common/cities`, params).then((response) => {
      return response.data;
    });
  }

  /**
   *  DI 중복 체크
   *  @param di {string} di
   *  @param userType {integer} userType
   */
  getIntDiCnt(params = {}) {
    return this.get(`/api/common/getIntDiCnt`, params).then((response) => {
      return response.data;
    });
  }

  getTermsCategoryGroup(params = {}) {
    return this.get(`/common/terms-category`, params).then((response) => {
      return response.data;
    });
  }

  /**
   *  타입별 약관 조회
   *  @param type {integer} type
   */
  getMapTerms(params = {}) {
    return this.get(`/common/terms`, params).then((response) => {
      return response.data;
    });
    // return this.get(`/common/getMapTerms`, params).then((response) => {
    //   return response.data;
    // });
  }
}

export default new CommonSvc();
